import TrackFocus from './utils/track-focus.js';
import setAttributes from './directives/setAttributes.js';
import AriaKeyboardListController from './controllers/aria-keyboard-list-controller.js';
import { StoryFormControlMethodAndProps } from './stories/formControlReusableStories.js';
if (typeof window !== 'undefined') {
    window._itAnalytics = window._itAnalytics || {};
    window._itAnalytics = {
        ...window._itAnalytics,
        version: '1.0.0-beta.3',
    };
}
export { TrackFocus, setAttributes, AriaKeyboardListController };
export { RovingTabindexController } from './controllers/roving-tabindex-controller.js';
export { BaseComponent, BaseLocalizedComponent, } from './base-component/base-component.js';
export { AriaKeyboardAccordionController, } from './controllers/aria-keyboard-accordion-controller.js';
export { CollapseAnimationController } from './controllers/collapse-controller.js';
export { FocusTrapController } from './controllers/focus-trap-controller.js';
export { FormControl } from './form/form-control.js';
export { formCollections, FormControlController } from './form/form-controller.js';
export { cookies } from './utils/cookies.js';
export { dispatchCancelable } from './utils/dispatch-cancelable.js';
export { focusableFallbackAncestor, nearestFocusableInDocument } from './utils/focus-fallback.js';
export { WindowManager } from './window-manager.js';
export { StoryFormControlMethodAndProps };
//# sourceMappingURL=index.js.map